import React, { useEffect, memo, Fragment } from 'react';
import PropTypes from 'prop-types';

const DateInput = ({
    row,
    label,
    name,
    values,
    onChange,
    readOnly,
    onFilter,
}) => {
    useEffect(() => {
        window.bronson.$$(`#${name}`).on('bronson_datepickerChange', event => {
            onFilter && onFilter();
            onChange(name, event?.detail?.args[1]);
        });
    }, [name, onChange, onFilter]);
    useEffect(() => {
        window.bronson.$$(`#${name}`).component('datepicker');
    }, []);
    return (
        <Fragment>
            <div>
                <span className="c-accordion__title"></span>
                <h6
                    className={`c-accordion__title ${
                        readOnly ? 'o-margin_create_ticket' : ''
                    }`}
                >
                    <button
                        className="c-accordion__title-label js-accordion__title-label"
                        aria-expanded="true"
                        type="button"
                    >
                        <label
                            htmlFor={name}
                            className="c-accordion__title-label-text "
                        >
                            {label}
                        </label>
                    </button>
                </h6>
            </div>
            <div
                className={`c-accordion__panel  js-accordion__panel c-ticket-filters__item-content ${
                    readOnly ? 'o-margin_create_ticket' : ''
                }`}
                aria-hidden="false"
            >
                <div
                    className={
                        'c-accordion__content c-vehicle-filters__' + name
                    }
                >
                    <div
                        id={name}
                        className="c-datepicker js-datepicker"
                        data-datepicker-month-selector-type="dropdown"
                        data-datepicker-date-format="d/m/Y"
                        data-datepicker-disable-mobile="true"
                    >
                        <div className="c-input">
                            <input
                                className="c-input__input flatpickr-input active"
                                type="text"
                                onChange={e => onChange(name, e.target.value)}
                                value={values[name]}
                                readOnly={readOnly}
                                data-input
                            />
                            <button
                                className="c-input__addon  c-input__addon--no-background"
                                aria-label="Toggle  datepicker"
                                type="button"
                                data-toggle
                                style={{ paddingRight: 0 }} //ICON TO RIGHT, SAME SPACE AS CHEVRON FOR SELECTS
                            >
                                <i
                                    className="c-icon  c-icon--[semantic-calendar]"
                                    aria-hidden="true"
                                    role="img"
                                />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

DateInput.propTypes = {
    title: PropTypes.string,
    readOnly: PropTypes.any,
    row: PropTypes.any,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    values: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default memo(DateInput);
